import store from 'redux/config'
import {RouterStates} from 'router/states/routerStates.enum'
import {TransitionHookType} from 'commonTypes'
import {RunDiagnostic, diagnosticsAC} from 'redux/diagnostics/diagnostics.duck'
import {
  select_gridSession,
  select_selectedUrl,
  select_selectedScript,
} from 'redux/diagnostics/selectors'
import {SortType} from 'api/graphQL/generated/graphql'

const {dispatch, getState} = store

export const getDiagnosticsHook: TransitionHookType = {
  criteria: {
    to: state => state?.name === RouterStates.diagnostics,
  },
  callback: transition => {
    const state = getState()
    const gridSession = select_gridSession(state)
    const selectedUrl = select_selectedUrl(state)
    const selectedScript = select_selectedScript(state)

    const {
      filters = gridSession.filters,
      pagination = gridSession.pagination,
      sorting = gridSession.sorting,
    } = transition.params()

    const shouldUsePrevSearch =
      filters.searchQuery === '' && gridSession.filters.searchQuery !== ''

    const effectiveFilters = shouldUsePrevSearch ? gridSession.filters : filters

    dispatch(diagnosticsAC.setSearchQuery(effectiveFilters.searchQuery))

    const sortState = sorting?.[0]
    const sortingInput = sortState?.id
      ? {
        column: sortState.id,
        direction: sortState.desc ? SortType.Desc : SortType.Asc,
      }
      : undefined

    if (selectedUrl && selectedScript) {
      dispatch(diagnosticsAC.updatePagination(pagination))
      dispatch(diagnosticsAC.updateSorting(sorting))
      dispatch(
        RunDiagnostic(
          selectedUrl,
          selectedScript,
          pagination.pageIndex * pagination.pageSize,
          pagination.pageSize,
          effectiveFilters.searchQuery,
          sortingInput
        )
      )
      dispatch(diagnosticsAC.clearDiagnosticDetailsItem())
    }
    else {
      dispatch(diagnosticsAC.clearResults())
    }
  },
}
